import cx from 'classnames';
import React from 'react';

type ModalBodyProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalBody: React.FC<ModalBodyProps> = ({ className, ...bodyProps }) => <div className={cx('topdk-modal__body', className)} {...bodyProps} />;

export default ModalBody;
